import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true, // required so the httpOnly JWT cookie is sent/received
});

export default api;
